import { Container } from '@/components/Container';
import { AppLink } from '@/components/AppLink';
import { SITE } from '@/data/site';

export function ContactStrip() {
  return (
    <section aria-label="Contact" className="border-t border-rule bg-white">
      <Container className="flex flex-wrap items-center justify-between gap-x-8 gap-y-3.5 py-8">
        <p className="m-0 font-serif text-h4 font-semibold text-navy-900">Questions? Contact the ITES office.</p>
        <div className="flex flex-wrap gap-x-7 gap-y-2.5 text-[1.0625rem] font-semibold">
          <a href={SITE.phoneHref} className="tap text-ink underline">{SITE.phone}</a>
          <a href={SITE.emailHref} className="tap text-ink underline">{SITE.email}</a>
          <AppLink href="/contact" className="tap underline">Contact &amp; directions →</AppLink>
        </div>
      </Container>
    </section>
  );
}
